import { render } from "./TemplateMessage.vue?vue&type=template&id=8d7bb0ee&scoped=true&ts=true"
import script from "./TemplateMessage.vue?vue&type=script&lang=ts"
export * from "./TemplateMessage.vue?vue&type=script&lang=ts"

import "./TemplateMessage.vue?vue&type=style&index=0&id=8d7bb0ee&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d7bb0ee"]])

export default __exports__